import React from "react";
import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/core/styles/withStyles";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import Slide from "@material-ui/core/Slide";
import LinearProgress from "@material-ui/core/LinearProgress";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import RemoveIcon from "@material-ui/icons/Remove";

import AnimatedLineChart from "../Charts/AnimatedLineChart.jsx";

import firebase from "firebase/app";
import "firebase/database";
import moment from "moment";

const styles = theme => ({
	MuiPaper: {
		root: { minWidth: "50%", backgroundColor: theme.palette.white }
	},
	dropIcon: {
		fill: "red",
		position: "relative",
		top: 6
	},
	upIcon: {
		fill: "green",
		position: "relative",
		top: 6
	},
	removeIcon: {
		fill: "blue",
		position: "relative",
		top: 6
	},
	content: {
		paddingLeft: 20
	},
	dialogContent: {
		padding: 2
	}
});

function Transition(props) {
	return <Slide direction="up" {...props} />;
}

class AlertDialogSlide extends React.Component {
	constructor() {
		super();
		this.state = { open: false, leagueData: [], loading: false };
	}

	componentDidUpdate = (prevProps, prevState) => {
		const { runner } = this.props;

		if (
			(runner && !prevProps.runner) ||
			(runner && runner[2] !== prevProps.runner[2])
		) {
			this.setState({ loading: true });
			firebase
				.database()
				.ref("usersLeague/" + runner[2])
				.once("value", leagueData => {
					console.log(leagueData.val());
					this.setState({ leagueData: leagueData.val(), loading: false });
				});
		}
	};

	getProgressIcon = section => {
		const { leagueData } = this.state;
		const { classes } = this.props;
		if (leagueData.prevRanking) {
			if (leagueData.prevRanking[section] < leagueData.ranking[section]) {
				return <ArrowDropDownIcon className={classes.dropIcon} />;
			} else if (
				leagueData.prevRanking[section] > leagueData.ranking[section]
			) {
				return <ArrowDropUpIcon className={classes.upIcon} />;
			}
		}
		return <RemoveIcon className={classes.removeIcon} />;
	};

	render() {
		const { open, close, runner, classes } = this.props;
		const { leagueData } = this.state;
		return (
			<div>
				{runner && (
					<Dialog
						open={open}
						TransitionComponent={Transition}
						keepMounted
						onClose={close}
						fullWidth={true}
						aria-labelledby="alert-dialog-slide-title"
						aria-describedby="alert-dialog-slide-description"
					>
						<DialogTitle id="alert-dialog-slide-title">
							<Typography
								variant="h6"
								id="alert-dialog-slide-title"
								component="div"
							>
								{runner[3]}
								<Typography variant="subtitle2">{runner[4]}</Typography>
							</Typography>
						</DialogTitle>
						<DialogContent className={classes.dialogContent}>
							{this.state.loading ? (
								<LinearProgress variant="query" />
							) : !leagueData || !leagueData.ranking ? (
								<Typography variant="body1">
									Sorry, results not found for this runner, please contact us if
									it is you
								</Typography>
							) : (
								<React.Fragment>
									<Typography
										variant="body1"
										component="div"
										className={classes.content}
									>
										{`Personal Best: ${leagueData.pb.split(".")[0]}`}
										<Typography variant="subtitle2">
											How does your PB compare?
										</Typography>
										{this.getProgressIcon("category")}
										{`Category Ranking: ${leagueData.ranking.category}`}
										<br />
										{this.getProgressIcon("gender")}
										{`Gender Ranking: ${leagueData.ranking.gender}`}
										<br />
										{this.getProgressIcon("overall")}
										{`Overall Ranking: ${leagueData.ranking.overall}`}
										<br />
										<ArrowDropUpIcon className={classes.upIcon} />
										{`Events Paticipated: ${
											Object.keys(leagueData.events).length
										}`}
										<br />
										<br />
									</Typography>
									{Object.keys(leagueData.events).length > 1 && (
										<AnimatedLineChart
											labels={Object.keys(leagueData.events)}
											series={Object.keys(leagueData.events).map(key => {
												return (
													Number(leagueData.events[key][5].split(":")[0]) +
													Number(leagueData.events[key][5].split(":")[1]) / 60
												);
											})}
										/>
									)}
									<Paper className={classes.root}>
										<Table className={classes.table}>
											<TableHead>
												<TableRow>
													<TableCell>Event Date</TableCell>
													<TableCell>Overall</TableCell>
													<TableCell>Category</TableCell>
													<TableCell>Time</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												{Object.keys(leagueData.events).map(key => {
													const row = leagueData.events[key];
													return (
														<TableRow key={key}>
															<TableCell component="th" scope="row">
																{moment(key, "YYYY-MM-DD").format("DD/MM/YY")}
															</TableCell>
															<TableCell>{row[0]}</TableCell>
															<TableCell>{row[1]}</TableCell>
															<TableCell>{row[5].split(".")[0]}</TableCell>
														</TableRow>
													);
												})}
											</TableBody>
										</Table>
									</Paper>
								</React.Fragment>
							)}
						</DialogContent>
						<DialogActions>
							<Button onClick={close} color="primary">
								Close
							</Button>
						</DialogActions>
					</Dialog>
				)}
			</div>
		);
	}
}

export default withStyles(styles)(AlertDialogSlide);
